export default {"src":"/_next/static/media/vue.fd0a02e5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};